import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Container } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';
import { getAllAuthors } from '../../services/Apis';

const PopularAuthors = () => {
    const { isSmallScreen } = useResponsive();
    const [authors, setAuthors] = useState([]);
    const [loading, setLoading] = useState(true); // loader state

    useEffect(() => {
        const fetchAuthors = async () => {
            const data = await getAllAuthors();
            setLoading(false);
            setAuthors(data);
        };
        fetchAuthors();
    }, []);

    return (
        <Container maxWidth="xl" width={"80%"} sx={{ pr: "0px !important", pl: "10px !important" }}>
            <Box p={2}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 600,
                            fontFamily: "Poppins",
                            color: "#CB4422",
                            borderLeft: "4px solid #000000",
                            paddingLeft: 1,
                        }}
                    >
                        Popular Authors
                    </Typography>
                </Box>
                {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <span className="red-dot" />
                        <span className="red-dot" style={{ animationDelay: '0.2s' }} />
                        <span className="red-dot" style={{ animationDelay: '0.4s' }} />
                    </Box>
                    <style>
                        {`
                        .red-dot {
                            display: inline-block;
                            width: 14px;
                            height: 14px;
                            border-radius: 50%;
                            background: #CB4422;
                            margin: 0 4px;
                            animation: bounce 1s infinite;
                        }
                        @keyframes bounce {
                            0%, 80%, 100% { transform: scale(1); opacity: 1; }
                            40% { transform: scale(1.4); opacity: 0.7; }
                        }
                        `}
                    </style>
                </Box>
            ):(<Box
                    sx={{
                        overflowX: 'auto',
                        width: '100%',
                        pb: 1,
                        '&::-webkit-scrollbar': { display: 'none' },
                        '-ms-overflow-style': 'none',
                        'scrollbar-width': 'none',
                    }}
                >
                    <Grid container spacing={2} sx={{ flexWrap: 'nowrap' }}>
                        {authors.map((author, index) => (
                            <Grid item xs={12} sm={6} md={2} key={index} sx={{ minWidth: 180 }}>
                                <Box
                                    sx={{
                                        borderRadius: '5px',
                                        overflow: 'hidden',
                                        height: isSmallScreen ? 250 : 200,
                                        position: 'relative',
                                        bgcolor: '#f5f5f5'
                                    }}
                                >
                                    <Box
                                        component="img"
                                        loading="lazy"
                                        src={author.image || author.imageUrl}
                                        alt={author.name}
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transition: 'transform 0.3s ease-in-out',
                                            '&:hover': {
                                                transform: 'scale(1.05)',
                                            },
                                            display: 'block',
                                        }}
                                    />
                                </Box>
                                <Box p={1.5}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: '13px',
                                            fontWeight: 580,
                                            color: 'text.primary',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {author.name}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>)}
            </Box>
        </Container>
    );
};

export default PopularAuthors;
